"use client";

import Link from "next/link";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { PublicExamsSection } from "@/app/(landing)/_components/catalog/public-exams-section";
import type { ExamCatalogEntry } from "@/types/exam-catalog";

// Eks AllExamsClient (kolam global) — kini milik zona, rename per fungsi.
// Navbar & Footer dirender oleh (landing)/layout.tsx. Komponen ini hanya
// bertanggung jawab atas breadcrumb + page-header ringan + grid ujian.
export function UjianView({
  initialExams,
}: {
  /** SSR seed dari server page — daftar ujian hadir di HTML awal (SEO). */
  initialExams?: ExamCatalogEntry[];
}) {
  return (
    <div className="bg-background relative overflow-hidden">
      <div className="gaming-float gaming-float-1" aria-hidden="true" />
      <div className="gaming-float gaming-float-3" aria-hidden="true" />

      {/* Breadcrumb — rata kiri (pola rumah; struktur konsisten dgn /blog,
          refactor 2026-09-25). */}
      <div className="relative mx-auto max-w-7xl px-4 pt-6 sm:px-6 lg:px-10">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink render={<Link href="/" />}>Beranda</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Katalog Ujian</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      {/* Page header — TERPUSAT mengikuti sumbu kapsul island di atasnya
          (rata kiri di bawah kapsul melayang = dua sumbu visual yang
          bertabrakan; audit proporsi 2026-09-25). Ritme identik /blog:
          breadcrumb pt-6 → hero pt-4 pb-2. Area kerja sidebar+grid di
          bawahnya tetap melebar max-w-7xl. */}
      <div className="relative mx-auto max-w-3xl px-4 pt-4 pb-2 text-center sm:px-6">
        <h1 className="text-foreground text-2xl font-black sm:text-3xl lg:text-4xl">
          Jelajahi <span className="text-primary">Ujian</span>
        </h1>
        <p className="text-foreground/60 mx-auto mt-2 max-w-lg text-sm font-medium sm:text-base">
          Temukan paket ujian yang sesuai dengan tujuanmu. Filter berdasarkan kategori,
          tipe, dan lainnya.
        </p>
      </div>

      {/* Content */}
      <div className="relative mx-auto max-w-7xl px-4 pt-6 pb-12 sm:px-6 lg:px-10">
        <PublicExamsSection initialExams={initialExams} showHeading={false} />
      </div>
    </div>
  );
}
